/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import logo from "assets/images/profile_icon.png";

import { useSelector } from "react-redux";
import { StoreType } from "../types/genericTypes";

import ModalComponent from "components/Modal";
import Footer from "examples/Footer";
import { Backdrop, Card, CardContent, CircularProgress, Grid, Typography } from "@mui/material";
import OrdenCompraModulo from "components/VistaModulos/OrdenCompraModulo";
import { useOrdenCompra } from "hooks/useOrdenCompra";
import DetallesOrdenCompra from "components/VistaModulos/DetallesOrdenCompra";
import BitacoraOrdenCompra from "components/VistaModulos/BitacoraOrdenCompra";

function OrdenCompra(): JSX.Element {
  const userName = useSelector((state: StoreType) => state?.app?.user?.data?.usuario || null);
  const fotoUser: any = useSelector((state: StoreType) => state?.app?.user?.data?.foto || logo);
  const nombreAutorizando = useSelector(
    (state: StoreType) => state?.app?.user?.data?.nombre || null
  );
  const apellidosAutorizando = useSelector(
    (state: StoreType) => state?.app?.user?.data?.apellidos || null
  );
  const nombreCompletoAutorizando = nombreAutorizando + " " + apellidosAutorizando;

  const {
    intl,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    ordenesCompra,
    ordenesCompraPaginadas,
    idUsuario,
    // productos
    detalles,
    setDetalles,
    //ver detalles de la requisicion
    isAlertOpenDetalleOrdenCompra,
    handleisAlertOpenDetalleOrdenCompra,
    handleisAlertCloseDetalleOrdenCompra,
    verDetalleOrdenCompra,
    setVerDetalleOrdenCompra,
    //mostrar bitacora de orden de compra
    getBitacoraOrdenCompra,
    bitacora,
    setBitacora,
    isAlertOpenBitacora,
    handleisAlertOpenBitacora,
    handleisAlertCloseBitacora,
  } = useOrdenCompra();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%", mt: 1 }}
            >
              <Grid xs={12}>
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  Ordenes de compra
                </Typography>
              </Grid>
              <Grid xs={12}>
                <OrdenCompraModulo
                  verOrdenesCompra={ordenesCompra}
                  ordenesCompraPaginadas={ordenesCompraPaginadas}
                  procesando={procesando}
                  handleisAlertOpenDetalleOrdenCompra={handleisAlertOpenDetalleOrdenCompra}
                  setVerDetalleOrdenCompra={setVerDetalleOrdenCompra}
                  getBitacoraOrdenCompra={getBitacoraOrdenCompra}
                  handleisAlertOpenBitacora={handleisAlertOpenBitacora}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/*<Footer />*/}
      {/* MODAL PARA VER DETALLES DE LA ORDEN DE COMPRA */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCloseDetalleOrdenCompra}
        isOpen={isAlertOpenDetalleOrdenCompra}
        key={"alerta-detalles"}
        titleButtonAction="Ver bitácora"
        handleAction={() => {
          if (!verDetalleOrdenCompra) return;
          const datos = {
            id_orden_compra: verDetalleOrdenCompra?.id,
          };
          getBitacoraOrdenCompra(datos);
          handleisAlertOpenBitacora();
        }}
      >
        {verDetalleOrdenCompra && (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <br />
              <br />
              <DetallesOrdenCompra
                verOrdenCompra={verDetalleOrdenCompra}
                usuarioArjion={userName}
                idUsuario={idUsuario}
                nombreCompletoAutorizando={nombreCompletoAutorizando}
              />
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      {/* MODAL PARA VER LA BITÁCORA DE LA ORDEN DE COMPRA */}
      <ModalComponent
        handleClose={handleisAlertCloseBitacora}
        isOpen={isAlertOpenBitacora}
        key={"alerta-bitacora"}
        titleButtonAction="Ver orden de compra"
        handleAction={() => {
          setVerDetalleOrdenCompra(verDetalleOrdenCompra);
          handleisAlertCloseBitacora();
          handleisAlertOpenDetalleOrdenCompra();
        }}
      >
        {bitacora && (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <br />
              <br />
              <BitacoraOrdenCompra bitacora={bitacora} procesando={procesando} />
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
    </DashboardLayout>
  );
}

export default OrdenCompra;
